import { formatAcquisitionDate } from "../../layers/imagery/formatImageryDate";

export default function CoverageImageryTable({ imagery }) {
    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm border border-slate-800">
                <thead className="bg-slate-900 text-left">
                    <tr>
                        <Th>Dataset</Th>
                        <Th>Date</Th>
                        <Th>Basin / Region</Th>
                        <Th>Status</Th>
                        <Th>% Covered</Th>
                    </tr>
                </thead>
                <tbody>
                    {imagery.map(row => (
                        <tr
                            key={row.dataset_id}
                            className="border-t border-slate-800 hover:bg-slate-900/40"
                        >
                            <Td>{row.name}</Td>
                            <Td>
                                {formatYearMonth(row.acquisition_date)}
                                {(() => {
                                    const age = getVintageAgeMonths(row.acquisition_date);
                                    return age !== null ? (
                                        <span className="text-slate-400 text-xs ml-1">
                                            · {age} mo
                                        </span>
                                    ) : null;
                                })()}
                            </Td>                            <Td>{row.basin} / {row.region}</Td>
                            <Td>
                                <CoverageBadge status={row.coverage_status} />
                            </Td>
                            <Td>{row.coverage_pct.toFixed(1)}%</Td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

function CoverageBadge({ status }) {
    const styles = {
        FULL: "bg-green-500/15 text-green-400 border-green-500/40",
        PARTIAL: "bg-yellow-500/15 text-yellow-400 border-yellow-500/40",
        NONE: "bg-red-500/15 text-red-400 border-red-500/40"
    };

    return (
        <span
            className={`px-2 py-1 rounded border text-xs font-medium ${styles[status]}`}
        >
            {status}
        </span>
    );
}

const Th = ({ children }) => (
    <th className="px-3 py-2 font-medium">{children}</th>
);

const Td = ({ children }) => (
    <td className="px-3 py-2">{children}</td>
);

// Delegates to the canonical formatter. This was a hand-rolled copy of it,
// one of SEVEN, and the day-precision change had to be made in each — see
// layers/imagery/formatImageryDate.js. Only the empty-value contract stays
// local, because callers differ on what a missing date should read as.
function formatYearMonth(value) {
    if (!value) return "—";
    return formatAcquisitionDate(value);
}

function getVintageAgeMonths(value) {
    if (!value) return null;

    // Day optional and ignored: this measures age in MONTHS, so two
    // acquisitions in one month are the same vintage.
    const match = value.match(/^(\d{4})_(\d{2})(?:_(\d{2}))?$/);
    if (!match) return null;

    const [, yearStr, monthStr] = match;

    const year = Number(yearStr);
    const month = Number(monthStr); // 1–12

    if (!year || month < 1 || month > 12) return null;

    const now = new Date();
    const nowYear = now.getUTCFullYear();
    const nowMonth = now.getUTCMonth() + 1; // 1–12

    return (nowYear - year) * 12 + (nowMonth - month);
}